<app-navigation *ngIf="settingsService?.routeHidden"></app-navigation>
<app-external-navbar
  *ngIf="!settingsService?.routeHidden"
></app-external-navbar>

<main
  [ngClass]="{
    'py-0 px-0 my-0 mx-0': !settingsService?.routeHidden,
    'mx-lg-5': settingsService?.routeHidden
  }"
  [ngStyle]="{
    'padding-left': settingsService?.sidenavExpanded ? '240px' : '48px'
  }"
>
  <div class="mt-3">
    <router-outlet></router-outlet>
  </div>
</main>

<div *ngIf="settingsService?.routeHidden">
  <app-footer></app-footer>
</div>
